
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"29","height":"27"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#A4A8C0","d":"M26 0a2.38 2.38 0 012.38 2.38V24A2.38 2.38 0 0126 26.38H2.38A2.38 2.38 0 010 24V2.38A2.38 2.38 0 012.38 0H26zm1.67 5.66H.75V24c0 .9.73 1.63 1.63 1.63H26A1.63 1.63 0 0027.67 24V5.66zm-4.09 2.43a1 1 0 011 1v13.06a1 1 0 01-1 1H4.83a1 1 0 01-1-1V9.09a1 1 0 011-1h18.75zM26 .75H2.38c-.9 0-1.63.73-1.63 1.63v2.53h26.92V2.38A1.63 1.63 0 0026 .75zM3.58 2.3a.74.74 0 01.732.632l.008.118a.75.75 0 01-.64.742l-.1.008a.76.76 0 01-.75-.75.75.75 0 01.648-.743L3.58 2.3zm2.88 0a.74.74 0 01.732.632l.008.118a.75.75 0 01-.64.742l-.1.008a.76.76 0 01-.75-.75.75.75 0 01.648-.743L6.46 2.3zm2.88 0a.74.74 0 01.732.632l.008.118a.75.75 0 01-.64.742l-.1.008a.76.76 0 01-.75-.75.75.75 0 01.648-.743L9.34 2.3z"}})])
          )
        }
      }
    